import { SET_LOGGED_IN_PORTFOLIO_FILTER, SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS, SET_LOGGED_IN_PORTFOLIO_LIST, SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT, SET_PORTFOLIO_FILTER, SET_PORTFOLIO_HELDAWAY_STATUS, SET_PORTFOLIO_LIST, SET_SELECTED_PORTFOLIO_OBJECT } from "../types/portfolioFilter";

export const storeSelectedPortfolio =
    (selectedPortfolio: { label: string, value: string }) => {
        return {
            type: SET_PORTFOLIO_FILTER,
            payload: selectedPortfolio,
        };
    };


export const storePortfolioList =
    (portfolioList: Array<{ label: string, value: string }>) => {
        return {
            type: SET_PORTFOLIO_LIST,
            payload: portfolioList,
        };
    };

export const setPortfolioHeldawayStatus =
    (isPortfolioHeldaway: boolean): { type: string; payload: boolean } => {
        return {
            type: SET_PORTFOLIO_HELDAWAY_STATUS,
            payload: isPortfolioHeldaway,
        };
    };

export const storeSelectedPortfolioObj =
    (selectedPortfolioObj: Record<string, any>) => {
        return {
            type: SET_SELECTED_PORTFOLIO_OBJECT,
            payload: selectedPortfolioObj,
        };
    };

export const clearSelectedPortfolioObj = ()=>{
      return{
        type: SET_SELECTED_PORTFOLIO_OBJECT,
        payload: {}
      }
}

// Stores the logged-in investor's portfolio snapshot. This should only be
// dispatched while the logged-in investor is viewing their own dashboard
// (i.e. NOT inside the family / view-as-other-investor flow), so it always
// reflects the logged-in user even when `selectedPortfolio` has been
// overridden by a clicked family member.
export const storeLoggedInSelectedPortfolio =
    (loggedInSelectedPortfolio: { label: string, value: string }) => {
        return {
            type: SET_LOGGED_IN_PORTFOLIO_FILTER,
            payload: loggedInSelectedPortfolio,
        };
    };

export const storeLoggedInSelectedPortfolioObj =
    (loggedInSelectedPortfolioObj: Record<string, any>) => {
        return {
            type: SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT,
            payload: loggedInSelectedPortfolioObj,
        };
    };

export const clearLoggedInSelectedPortfolioObj = () => {
    return {
        type: SET_LOGGED_IN_SELECTED_PORTFOLIO_OBJECT,
        payload: {}
    }
}

export const storeLoggedInPortfolioList =
    (loggedInPortfolioList: Array<{ label: string, value: string }>) => {
        return {
            type: SET_LOGGED_IN_PORTFOLIO_LIST,
            payload: loggedInPortfolioList,
        };
    };

export const setLoggedInPortfolioHeldawayStatus =
    (loggedInIsPortfolioHeldaway: boolean): { type: string; payload: boolean } => {
        return {
            type: SET_LOGGED_IN_PORTFOLIO_HELDAWAY_STATUS,
            payload: loggedInIsPortfolioHeldaway,
        };
    };